import script from "./ProductionProjectsDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionProjectsDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ProductionProjectsDashboard.vue?vue&type=style&index=0&id=406dc670&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-406dc670"]])

export default __exports__